'use client'

import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

// Step 1 — the account email. Trimmed before validation so surrounding whitespace
// doesn't trip the format check.
const emailSchema = yup.object({
  email: yup.string().trim().email('Veuillez saisir une adresse email valide.').required('Veuillez saisir une adresse email valide.'),
})

// Step 2 — the 6-digit email OTP.
const otpSchema = yup.object({
  otp: yup
    .string()
    .matches(/^\d{6}$/, 'Le code doit comporter 6 chiffres.')
    .required(),
})

export type EmailFormData = yup.InferType<typeof emailSchema>
export type OtpFormData = yup.InferType<typeof otpSchema>

export function useEmailForm() {
  return useForm<EmailFormData>({
    resolver: yupResolver(emailSchema),
    defaultValues: { email: '' },
  })
}

export function useOtpForm() {
  return useForm<OtpFormData>({
    resolver: yupResolver(otpSchema),
    defaultValues: { otp: '' },
  })
}
